import ScreenReaderAnnouncement from './ScreenReaderAnnouncement';

export default ScreenReaderAnnouncement;
